import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const TAB_CONTENT_HEIGHT = "480px";

const fadeSlideIn = {
  from: {
    opacity: 0,
    transform: "translateY(4px)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0)",
  },
};

export const useStyles = makeStyles({
  dialogSurfaceOverride: {
    "@media (max-width: 640px)": {
      minWidth: "unset",
      width: "calc(100vw - 32px)",
      maxWidth: "100%",
    },
  },
  dialogContent: {
    height: TAB_CONTENT_HEIGHT,
    maxHeight: "60vh",
    "@media (max-width: 640px)": {
      maxHeight: "50vh",
    },
  },
  scrollableContent: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto" as const,
  },
  dialogContentLoading: {
    overflowY: "hidden",
  },
  errorMessage: {
    color: designTokens.semantic.error,
    marginTop: designTokens.spacing[2],
    fontSize: designTokens.fontSize.sm,
    animationName: fadeSlideIn,
    animationDuration: "150ms",
    animationFillMode: "both",
  },
  helperText: {
    marginTop: designTokens.spacing[1],
    opacity: 0.7,
    fontSize: designTokens.fontSize.xs,
  },
  messagesEditor: {
    flex: 1,
    "& .quill": {
      height: "150px",
    },
  },
  colorPickerRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[1],
  },
  hexInput: {
    width: "110px",
    fontFamily: "'Consolas', 'Courier New', monospace",
  },
  colorInput: {
    width: "48px",
    height: "36px",
    padding: designTokens.spacing[1],
    border: `1px solid ${designTokens.neutral[300]}`,
    borderRadius: designTokens.borderRadius.md,
    cursor: "pointer",
    backgroundColor: "transparent",
  },
  colorPreview: {
    width: "36px",
    height: "36px",
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${designTokens.neutral[300]}`,
    flexShrink: 0,
  },
  logoPreviewWrapper: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
    marginTop: designTokens.spacing[1],
  },
  logoPreview: {
    maxHeight: "48px",
    maxWidth: "200px",
    objectFit: "contain" as const,
    border: `1px solid ${designTokens.neutral[200]}`,
    borderRadius: designTokens.borderRadius.md,
    padding: designTokens.spacing[1],
  },
  previewLabel: {
    display: "block",
    color: designTokens.neutral[500],
    marginBottom: designTokens.spacing[2],
    textTransform: "uppercase" as const,
    letterSpacing: "0.05em",
  },
  brandingTabLayout: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  brandingFormColumn: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  brandingPreviewColumn: {
    display: "flex",
    flexDirection: "column",
  },
});
